<h2>This is demo site for ngx-noty</h2>

<div>
  <button (click)="alert()">Alert</button>
</div>

<div>
  <button (click)="success()">Success</button>
</div>

<div>
  <button (click)="warning()">Warning</button>
</div>

<div>
  <button (click)="error()">Error</button>
</div>

<div>
  <button (click)="info()">Info</button>
</div>
